import { render } from "./ProgressBar.vue?vue&type=template&id=fad36fb2&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"

import "./ProgressBar.vue?vue&type=style&index=0&id=fad36fb2&scoped=true&lang=scss"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad36fb2"]])

export default __exports__